import { render, staticRenderFns } from "./crags.vue?vue&type=template&id=3b0c1e0a"
import script from "./crags.vue?vue&type=script&lang=js"
export * from "./crags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports